import React, { useEffect, useState } from "react";
import axios from "axios";
import FileManager from "../../utils/FileManager.js";
import {
  getWordOfOtherGender,
  getHobby,
  getWordByGender,
} from "../../handlers/dictionaryHandler.js";

const GetOneProfile = ({
  otherId,
  profileData = null,
  embedded = false,
  showPrivateDetails = true,
  profileTitle = "",
  displayGender,
}) => {
  const [details1, setDetails1] = useState("");
  const [freeText1, setfreeText1] = useState("");
  const [cellFriend1, setCellFriend1] = useState("");
  const [image1a, setImage1a] = useState("");
  const [image1aBlobURL, setImage1aBlobURL] = useState("");
  const [religous1, setReligous1] = useState("");
  const [tall1, setTall1] = useState("");
  const [education1, setEducation1] = useState("");
  const [status1, setStatus1] = useState("");
  const [hobbies1, setHobbies1] = useState("");
  const [hobbieFree, setHobbieFree] = useState("");
  const [occupation1, setOccupation1] = useState("");
  const [origin1, setOrigin1] = useState("");
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [imageLoadFailed, setImageLoadFailed] = useState(false);

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };

  const getGenderedWord = (key) =>
    displayGender == 2 ? getWordByGender(key) : getWordOfOtherGender(key);

  useEffect(() => {
    let isMounted = true;

    console.log("GetOneProfile received profileData:", profileData);

    const setProfileDetails = async (data) => {
      if (!data || !isMounted) {
        return;
      }
      setDetails1(data.details ?? "");
      setfreeText1(data.freeText ?? "");
      setCellFriend1(data.cellFriend ?? "");
      setReligous1(data.religous ?? "");
      setTall1(data.tall ?? "");
      setEducation1(data.education ?? "");
      setStatus1(data.status ?? "");
      setOccupation1(data.occupation ?? "");
      setOrigin1(data.origin ?? "");
      setHobbies1(data.hobbies ?? "");
      setHobbieFree(data.hobbieFree ?? "");

      // איפוס התמונה הקודמת לפני טעינת תמונה חדשה
      // איפוס התמונה הקודמת לפני טעינת תמונה חדשה
      setImage1a("");
      setImage1aBlobURL("");
      setImageLoadFailed(false);

      if (data.keyImage1) {
        setIsImageLoading(true);

        try {
          const image1Data = await FileManager.getFile(data.keyImage1);

          if (isMounted) {
            setImage1a(image1Data.file);
            setImage1aBlobURL(image1Data.blobURL);
          }
        } catch (error) {
          console.log("Failed loading profile image", error);

          if (isMounted) {
            setImageLoadFailed(true);
            setIsImageLoading(false);
          }
        }
      } else {
        setIsImageLoading(false);
      }
    };

    const loadData = async () => {
      try {
        /*
         * מצב מוטמע:
         * הנתונים כבר הגיעו מהקומפוננטה העוטפת,
         * ולכן אין צורך בקריאת שרת נוספת.
         */
        if (profileData) {
          await setProfileDetails(profileData);
          return;
        }

        /*
         * מצב רגיל:
         * אין profileData ולכן ממשיכים בדיוק כמו קודם
         * וטוענים את הפרופיל לפי otherId.
         */
        if (!otherId) {
          return;
        }

        const response = await axios.post(
          process.env.REACT_APP_LOCALHOST_ADDRESS + "/getOneProfile",
          { idProfile: otherId },
          config,
        );

        const data = response.data?.[0]?.[0];

        if (data) {
          await setProfileDetails(data);
        }
      } catch (error) {
        console.log(error);
      }
    };

    loadData();

    return () => {
      isMounted = false;
    };
  }, [otherId, profileData]);

  const [showImageModal, setShowImageModal] = useState(false);

  const content = (
    <div className={embedded ? "profile-body-embedded" : "signup-body"}>
      <div className="one-profile-main-area">
        {isImageLoading || image1aBlobURL ? (
          <div className="one-profile-image-wrapper">
            {isImageLoading && (
              <div className="one-profile-image-loading">
                <div className="one-profile-image-spinner" />
                <span>התמונה נטענת...</span>
              </div>
            )}

            {image1aBlobURL && (
              <img
                className="one-profile-main-image"
                src={image1aBlobURL}
                alt={profileTitle || details1 || "תמונת פרופיל"}
                onLoad={() => setIsImageLoading(false)}
                onError={() => {
                  setIsImageLoading(false);
                  setImageLoadFailed(true);
                }}
                onClick={() => {
                  if (!isImageLoading) {
                    setShowImageModal(true);
                  }
                }}
                style={{
                  visibility: isImageLoading ? "hidden" : "visible",
                }}
              />
            )}

            <div className="one-profile-title-overlay">
              {profileTitle || details1}
            </div>

            {showImageModal && image1aBlobURL && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  background: "rgba(0,0,0,0.7)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 9999,
                }}
                onClick={() => setShowImageModal(false)}
              >
                <img
                  src={image1aBlobURL}
                  alt={details1 || "תמונת פרופיל"}
                  style={{
                    maxWidth: "90vw",
                    maxHeight: "90vh",
                    borderRadius: "10px",
                    boxShadow: "0 0 20px #000",
                    cursor: "zoom-out",
                  }}
                  onClick={() => setShowImageModal(false)}
                />
              </div>
            )}
          </div>
        ) : (
          <div className="one-profile-title-without-image">
            {details1}
            {imageLoadFailed && (
              <div className="one-profile-image-error">
                לא הצלחנו לטעון את התמונה
              </div>
            )}
          </div>
        )}
        <div className="one-profile-details">
          <div className="messegeMatch one-profile-summary">
            {getGenderedWord("pdat" + religous1)} • {tall1} ס"מ •{" "}
            {getGenderedWord("psta" + status1)}
          </div>

          <div className="messegeMatch one-profile-education-occupation">
            <span>
              <strong>השכלה:</strong> {getGenderedWord("pedu" + education1)}
            </span>

            <span className="one-profile-separator">•</span>

            <span>
              <strong>עיסוק:</strong> {occupation1}
            </span>
          </div>

          <div className="messegeMatch">
            <strong>מוצא:</strong> {origin1}
          </div>

          <h5>תחביבים</h5>

          <div className="messegeMatch">
            {hobbies1
              ? hobbies1
                  .split(",")
                  .map((current) => getHobby(current))
                  .join(", ")
              : ""}

            {hobbies1 && hobbieFree ? ", " : ""}
            {hobbieFree || ""}
          </div>
        </div>
      </div>

      <div className="one-profile-free-text">
        <h5>קצת עליי</h5>
        {showPrivateDetails ? (
          <div className="messegeMatch">{freeText1}</div>
        ) : (
          <div className="messegeMatch">הטקסט מופיע כאשר אחד מהצדדים מנוי</div>
        )}
      </div>

      {showPrivateDetails && (
        <div className="one-profile-contact-area">
          <div>
            <h5>טלפון של חבר/ה לבירורים</h5>
            <div className="messegeMatch">{cellFriend1}</div>
          </div>

          <div
            className="smalllogo"
            style={{
              rotate: "-20deg",
              height: "70px",
              width: "70px",
              margin: 0,
            }}
          />
        </div>
      )}
    </div>
  );

  return embedded ? (
    content
  ) : (
    <form className="supermatchmaker-form">{content}</form>
  );
};

// לאפשר ליצור קשר עם מועמד עי סמס רק אם אתה מנוי.
// ליצור חלון שהצד השני יראה את ההתאמה הקודמת
// לאפשר לראות התאמה קודמת רק אם הצד השני לא אמר שלא מתאים

export default GetOneProfile;
